<template>
  <Card v-if="proxyPerson">
    <template slot="header">Delete Account</template>
    Delete the account for {{ person.firstName }} {{ person.lastName }} ({{ person.personID }})<br>
    Identifying data will be stripped from this account and it will no longer be usable.<br>
    <v-btn
      @click="submit()"
    >
      Delete
    </v-btn>
  </Card>
</template>

<script>
import { mapGetters, mapActions } from 'vuex'
export default {
  computed: {
    ...mapGetters({
      proxyPerson: 'person/proxyPerson'
    })
  },
  methods: {
    ...mapActions({
      deletePerson: 'person/deletePerson'
    }),
    submit () {
      let confirmed = confirm('Are you sure?')
      if (confirmed) {
        this.deletePerson()
      }
    }
  }
}
</script>
